import { Theme, useMediaQuery } from "@mui/material";

export const useIsMobile = (): boolean => {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))
};